import React from 'react';

const ErrorModal = ({ message, onClose }) => {
  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center p-4">
          <div className="modal-body">
            <h5 className="mb-3 text-danger">❌ Error</h5>
            <p>{message}</p>
            <button className="btn btn-danger mt-3" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
